import { render, staticRenderFns } from "./iconHeadset.vue?vue&type=template&id=10357546&scoped=true"
import script from "./iconHeadset.vue?vue&type=script&lang=js"
export * from "./iconHeadset.vue?vue&type=script&lang=js"
import style0 from "./iconHeadset.vue?vue&type=style&index=0&id=10357546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10357546",
  null
  
)

export default component.exports